// The groups that make someone a customer.
//
// MUST MATCH PORTAL_GROUP in ../server/portal-guard.js. The server's copy is
// the one that enforces — it refuses every surface but the portal — and this
// copy only decides where to SEND someone. They are separate because a
// browser bundle cannot import a server module, and the desk suite fails if
// they ever drift apart: a redirect that named a group the guard did not
// would drop customers back into a shell that refuses them everything.
//
// Since 2026-10-28 a desk may have its own sign-up, whose people join the
// desk's group instead of portal-customers. Those groups live in the
// database: the shell asks the server for the whole list (usePortalGroups.js)
// and sends a member of ANY of them to the portal. Pure — the suite imports
// this file in Node.
export const PORTAL_CUSTOMER_GROUP = 'portal-customers';

/** True when any of `userGroups` is a portal group. Trimmed both sides. */
export function inPortalGroups(userGroups, portalGroups) {
  const portal = new Set((portalGroups || [PORTAL_CUSTOMER_GROUP]).map((g) => String(g).trim()));
  return (userGroups || []).some((g) => portal.has(String(g).trim()));
}
